import React from "react";
import PropTypes from "prop-types";

class PlayerInfoIcon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.iconOnClick = this.iconOnClick.bind(this);
  }

  componentDidMount() {
    this.props.object.opened = false;
  }

  iconOnClick() {
    this.openInfo();
  }

  openInfo() {
    this.props.object.opened = true;
  }

  render() {
    var {
      prefab_label = "Utwórz prefab",
      name,
      icon_image: { downloadURL: iconDownloadURL = "" } = {},
      icon_width = "100px",
      window_image: { downloadURL: windowDownloadURL = "" } = {}
    } = this.props.prefab ? this.props.prefab : this.props.object;
    const divStyle = {
      width: "auto",
      height: "auto",
      WebkitTransform: "translate(-50%, -50%)",
      MozTransform: "translate(-50%, -50%)",
      OTransform: "translate(-50%, -50%)",
      transform: "translate(-50%, -50%)",
      cursor: "pointer",
      boxSizing: "border-box",
      display: "inline-block",
      position: "absolute",
      top: "0",
      left: "0"
    };
    return (
      <div
        className="PlayerInfoIcon"
        style={this.props.style ? this.props.style : divStyle}
      >
        {iconDownloadURL !== "" && (
          <img
            onClick={this.iconOnClick}
            onTouchStart={this.iconOnClick}
            style={{
              position: "relative",
              width: icon_width,
              height: "auto",
              backgroundColor: iconDownloadURL
            }}
            src={iconDownloadURL}
          />
        )}
        {iconDownloadURL == "" && (
          <div
            onClick={this.iconOnClick}
            onTouchStart={this.iconOnClick}
            style={{
              position: "relative",
              width: icon_width,
              height: icon_width,
              border: parseInt(icon_width) * 0.15 + "px solid white",
              borderRadius: icon_width,
              color: "white",
              fontSize: parseInt(icon_width) * 0.5 + "px",
              fontWeight: "bold",
              lineHeight: parseInt(icon_width) * 0.7 + "px",
              opacity: 0.75
            }}
          >
            i
          </div>
        )}
      </div>
    );
  }
}

PlayerInfoIcon.propTypes = {
  onClick: PropTypes.func
};

export default PlayerInfoIcon;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerInfoIcon/PlayerInfoIcon.js